import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { searchgame, searchplatform, searchchannel, searchpkg } from "@/api/dataAll/dataAll";
import { addpaymentConfig, updatapaymentConfig, returnpaymentConfig } from "@/api/pakgConfig/paymentConfig";
export default {
  name: "addpaymentConfig",
  data: function data() {
    return {
      form: {
        id: "",
        n_game: "",
        n_platform: "",
        n_channel: "",
        n_pkg: "",
        o_game: "",
        o_platform: "",
        o_channel: "",
        o_pkg: "",
        kind: 1
      },
      show: false,
      searchgames: [],
      n_searchplatform: [],
      n_searchchannel: [],
      n_searchpkg: [],
      o_searchplatform: [],
      o_searchchannel: [],
      o_searchpkg: [],
      rules: {
        n_game: [{
          required: true,
          message: "新游戏",
          trigger: "blur"
        }],
        n_platform: [{
          required: true,
          message: "新平台",
          trigger: "blur"
        }],
        n_channel: [{
          required: true,
          message: "新渠道",
          trigger: "blur"
        }],
        n_pkg: [{
          required: true,
          message: "新包名",
          trigger: "blur"
        }],
        o_game: [{
          required: true,
          message: "替换游戏",
          trigger: "blur"
        }],
        o_platform: [{
          required: true,
          message: "替换平台",
          trigger: "blur"
        }],
        o_channel: [{
          required: true,
          message: "替换渠道",
          trigger: "blur"
        }],
        o_pkg: [{
          required: true,
          message: "替换包名",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.show = true;
                searchgame().then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                    var _yield$returnpaymentC, data;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _this.searchgames = res.data;

                            if (!id) {
                              _context.next = 19;
                              break;
                            }

                            _context.next = 4;
                            return returnpaymentConfig({
                              id: id
                            });

                          case 4:
                            _yield$returnpaymentC = _context.sent;
                            data = _yield$returnpaymentC.data;
                            _this.form = _objectSpread({}, data);
                            _context.next = 9;
                            return _this.gamechange(data.n_game, 'n_', true);

                          case 9:
                            _context.next = 11;
                            return _this.platformchange(data.n_platform, 'n_', true);

                          case 11:
                            _context.next = 13;
                            return _this.channelchange(data.n_channel, 'n_', true);

                          case 13:
                            _context.next = 15;
                            return _this.gamechange(data.o_game, 'o_', true);

                          case 15:
                            _context.next = 17;
                            return _this.platformchange(data.o_platform, 'o_', true);

                          case 17:
                            _context.next = 19;
                            return _this.channelchange(data.o_channel, 'o_', true);

                          case 19:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    resetForm: function resetForm() {
      this.$emit("changeShow", false);
      this.show = false;
      this.clearData();
    },
    gamechange: function gamechange(game_mark, type, cleara) {
      var _this2 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve, reject) {
          var id;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.t0 = !cleara;

                  if (!_context3.t0) {
                    _context3.next = 4;
                    break;
                  }

                  _context3.next = 4;
                  return _this2.dataCleaning('game', type);

                case 4:
                  if (game_mark != "") {
                    id = _this2.searchgames.filter(function (item) {
                      return item.game_mark == game_mark;
                    })[0].id;
                    searchplatform({
                      game_id: id
                    }).then(function (res) {
                      _this2[type + 'searchplatform'] = res.data;
                      resolve();
                    });
                  }

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    platformchange: function platformchange(platform_mark, type, cleara) {
      var _this3 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(resolve, reject) {
          var id;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.t0 = !cleara;

                  if (!_context4.t0) {
                    _context4.next = 4;
                    break;
                  }

                  _context4.next = 4;
                  return _this3.dataCleaning('platform', type);

                case 4:
                  if (platform_mark != "") {
                    id = _this3[type + 'searchplatform'].filter(function (item) {
                      return item.platform_mark == platform_mark;
                    })[0].id;
                    searchchannel({
                      platform_id: id
                    }).then(function (res) {
                      _this3[type + 'searchchannel'] = res.data.channel;
                      resolve();
                    });
                  }

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x4, _x5) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    channelchange: function channelchange(channel_mark, type, cleara) {
      var _this4 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resolve, reject) {
          var id;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.t0 = !cleara;

                  if (!_context5.t0) {
                    _context5.next = 4;
                    break;
                  }

                  _context5.next = 4;
                  return _this4.dataCleaning('channel', type);

                case 4:
                  if (channel_mark != "") {
                    id = _this4[type + 'searchchannel'].filter(function (item) {
                      return item.channel_mark == channel_mark;
                    })[0].id;
                    searchpkg({
                      channel_id: id
                    }).then(function (res) {
                      _this4[type + 'searchpkg'] = res.data;
                      resolve();
                    });
                  }

                case 5:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x6, _x7) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this5 = this;

      this.$refs.form.validate(function (valid) {
        if (valid) {
          var req = _this5.form.id ? updatapaymentConfig : addpaymentConfig;
          req(_this5.form).then(function (res) {
            if (res.status == 200) {
              Message.success('操作成功');

              if (_this5.form.id) {
                _this5.$emit("refreshDataList");
              }
            }

            _this5.resetForm("ruleForm");
          });
        }
      });
    },
    dataCleaning: function dataCleaning(value, type) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        if (!value) {
          reject();
          return;
        }

        var t = false;
        var s = {
          game: '',
          platform: '',
          channel: '',
          pkg: ''
        };

        for (var key in s) {
          if (t) {
            _this6.form[type + key] = '';
            _this6[type + 'search' + key] = [];
          }

          if (value == key) {
            t = true;
          }
        }

        resolve();
      });
    },
    clearData: function clearData() {
      this.form = {
        id: this.form.id,
        n_game: "",
        n_platform: "",
        n_channel: "",
        n_pkg: "",
        o_game: "",
        o_platform: "",
        o_channel: "",
        o_pkg: "",
        kind: 1
      };
      this.n_searchplatform = [], this.n_searchchannel = [], this.n_searchpkg = [], this.o_searchplatform = [], this.o_searchchannel = [], this.o_searchpkg = [], this.$refs.form.clearValidate();
    }
  }
};